"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDetailUpdate = void 0;
const react_1 = require("react");
const web_socket_context_1 = require("../../common/web-socket/web-socket-context");
const detail_types_1 = require("./detail-types");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
function useDetailUpdate({ enabled, source, mode, }) {
    var _a;
    const { subscribe, unsubscribe } = react_1.useContext(web_socket_context_1.WebsocketContext);
    const id = (_a = source.data) === null || _a === void 0 ? void 0 : _a.id;
    const handleNotify = event_callback_hook_1.useEventCallback(() => {
        if (mode === detail_types_1.DetailMode.VIEW) {
            source.refresh();
        }
    });
    react_1.useEffect(() => {
        const subscription = enabled && id !== undefined
            ? subscribe(`/topic/entity/${id}/update`, handleNotify)
            : undefined;
        return () => {
            if (subscription !== undefined) {
                unsubscribe(subscription);
            }
        };
    }, [enabled, handleNotify, id, subscribe, unsubscribe]);
}
exports.useDetailUpdate = useDetailUpdate;
//# sourceMappingURL=detail-update-hook.js.map